import { createFileRoute } from "@tanstack/react-router";
import { HeroBanner } from "@/components/HeroBanner";
import { CONTACT } from "@/config/contact";
import { buildSeoMeta } from "@/lib/seo";
import { openCookieSettings } from "@/components/CookieConsent";
import { buildBreadcrumbJsonLd } from "@/lib/breadcrumb-jsonld";

const BREADCRUMB = buildBreadcrumbJsonLd([
  { name: "Forside", path: "" },
  { name: "Privatliv & cookies", path: "privatliv" },
]);

export const Route = createFileRoute("/privatliv")({
  head: () => buildSeoMeta({
    title: "Privatlivspolitik & cookies · AutoXChange",
    description:
      "Sådan behandler AutoXChange dine personoplysninger og bruger cookies. Læs om dine rettigheder under GDPR.",
    path: "/privatliv",
  }),
  component: Privatliv,
});

function Privatliv() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: BREADCRUMB }} />
      <HeroBanner title="Privatliv & cookies" subtitle="Vi behandler dine data med respekt" />
      <section className="bg-background py-16">
        <div className="mx-auto max-w-3xl px-6 prose prose-neutral dark:prose-invert">
          <h2>Dataansvarlig</h2>
          <p>
            {CONTACT.companyName} (CVR {CONTACT.cvr}), {CONTACT.addressLine}, er dataansvarlig for de
            personoplysninger du afgiver via vores hjemmeside. Kontakt: <a href={CONTACT.emailHref}>{CONTACT.email}</a>.
          </p>
          <h2>Hvilke oplysninger indsamler vi?</h2>
          <ul>
            <li><strong>Kontaktformularer:</strong> navn, e-mail, telefon, evt. besked og bil-interesse.</li>
            <li><strong>Cookies:</strong> tekniske cookies (nødvendige), analytiske og marketing-cookies (kun ved samtykke).</li>
            <li><strong>Trafikdata:</strong> IP-adresse, browser, besøgte sider — anonymiseret medmindre du giver samtykke til analyse.</li>
          </ul>
          <h2>Formål og retsgrundlag</h2>
          <p>
            Henvendelser besvares på baggrund af legitime interesser (GDPR art. 6.1.f). Marketing-tracking
            sker kun med dit samtykke (art. 6.1.a). Du kan til enhver tid trække samtykket tilbage via{" "}
            <button type="button" onClick={openCookieSettings} className="text-accent underline">cookie-indstillinger</button>.
          </p>
          <h2>Opbevaring</h2>
          <p>
            Henvendelser slettes senest 3 år efter sidste kontakt. Bogføringsmateriale opbevares i 5 år
            jf. bogføringsloven. Anonymiserede analysedata kan opbevares længere.
          </p>
          <h2>Videregivelse</h2>
          <p>
            Vi deler kun data med databehandlere (hosting, e-mail, analyseværktøjer) under
            databehandleraftaler. Vi videregiver aldrig data til tredjelande uden lovligt overførselsgrundlag.
          </p>
          <h2>Dine rettigheder</h2>
          <p>
            Du har ret til indsigt, berigtigelse, sletning, begrænsning, dataportabilitet og indsigelse.
            Klager kan rettes til Datatilsynet (<a href="https://datatilsynet.dk" target="_blank" rel="noopener noreferrer">datatilsynet.dk</a>).
          </p>
          <h2>Cookies</h2>
          <p>
            Vi bruger nødvendige cookies (login, session), analytiske cookies (Google Analytics — kun ved
            samtykke) og marketing-cookies (Meta Pixel, Google Ads — kun ved samtykke). Tilpas dit samtykke{" "}
            <button type="button" onClick={openCookieSettings} className="text-accent underline">her</button>.
          </p>
        </div>
      </section>
    </>
  );
}
